import React, { useEffect, useState } from "react";
import { LinearProgress, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import { useNavigate } from "react-router-dom";
import LoginBanner from "../nav/LoginBanner";
import { useNav } from "../../context/NavProvider";
import { useUtils } from "../../context/UtilsProvider";
import { useAuth } from "../../context/AuthProvider";
import IdvLoginCard from "../auth/IdvLogInCard";
import ScriptLoader from "../account/ScriptLoader";
import { useClient } from "../../context/ClientProvider";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

function IdvAuthPage() {

  const { setShowFooter } = useNav();
  setShowFooter(false);

  const { setFormState, formState } = useUtils();
  const { useGetAuthUser } = useAuth();
  const { user, isLoading } = useGetAuthUser();
  const navigate = useNavigate();
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  const [showBanner, setShowBanner] = useState(true)

  useEffect(() => {
    if (!formState) {
      setFormState({
        accountReference: "",
        postcode: "",
        dateOfBirth: "",
      });
    }
  }, [formState, setFormState]);

  if (isLoading) {
    return <LinearProgress />;
  }

  if (user) {
    navigate("/");
    return null;
  }

  const handleBannerClose = () => {
    setShowBanner(false);
  };

  return (
    <>
      <ScriptLoader />
      {formState && (
        <>{clientConfig?.layout?.loginBanner?.enabled && showBanner && <Alert severity="info" onClose={handleBannerClose} sx={{
          color: '#000',
          backgroundColor: '#FDF8EB',
          '& .MuiAlert-icon': {
            mt: '5px',
            color: '#E9A600'
          }
        }}> <AlertTitle sx={{
          fontWeight: 'bold',
          color: '#000',
          padding: '6px',
          borderRadius: '4px'
        }}>{clientConfig.layout.loginBanner.headerText}</AlertTitle>
          <Typography sx={{ padding: '8px', }}>{clientConfig.layout.loginBanner.paragraphText}</Typography>
        </Alert>}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <LoginBanner />
          </Box>
          <Container sx={{ mt: 4, mb: 7, paddingBottom: "350px" }}>
            <Box
              sx={{
                mt: 0,
              }}
            >
              <IdvLoginCard />
            </Box>
          </Container>
          {setShowFooter(true)}
        </>
      )}
    </>
  );
}

export default IdvAuthPage;
